export const SCROLL_TO_CLASS = 'digiLifeLoanProtection/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'digiLifeLoanProtection/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'digiLifeLoanProtection/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}

export const resetScroll = () => ({ type: CLEAR_SCROLL });